export const DEFAULT_TOGGLE_CONTAINER_STYLE =
  'flex cursor-pointer items-center rounded-full p-1 h-[26px] w-full max-w-[55px] md:h-6 md:w-12 md:max-w-[25%] ';
export const DEFAULT_TOGGLE_SWITCH_STYLE =
  'h-[20px] w-[20px] transform rounded-full shadow-md duration-300 ease-in-out md:h-[18px] md:w-[18px] ';

export const DISABLED_TOGGLE_CONTAINER_STYLE = `${DEFAULT_TOGGLE_CONTAINER_STYLE} bg-secondary-gray`;
export const DISABLED_TOGGLE_SWITCH_STYLE = `${DEFAULT_TOGGLE_SWITCH_STYLE} bg-accent-light-gray`;

export const TOGGLE_THEMES = {
  LIGHT: 'Light',
  DARK: 'Dark'
};

export const TOGGLE_CONTAINER_STYLE = {
  [TOGGLE_THEMES.LIGHT]: `${DEFAULT_TOGGLE_CONTAINER_STYLE} border border-secondary-blue-gray bg-primary-gray`,
  [TOGGLE_THEMES.DARK]: `${DEFAULT_TOGGLE_CONTAINER_STYLE} bg-primary-blue`
};

export const TOGGLE_SWITCH_STYLE = {
  [TOGGLE_THEMES.LIGHT]: `${DEFAULT_TOGGLE_SWITCH_STYLE} bg-primary-blue`,
  [TOGGLE_THEMES.DARK]: `${DEFAULT_TOGGLE_SWITCH_STYLE} bg-primary-white`
};
